import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { doPost } from "../../../config/fetchWrapper";
import { urls } from "../../endPoints";

export const playbookBatchQuestions = createAsyncThunk(
  "playbookBatchQuestions",
  async (arg, { rejectWithValue }) => {
    try {
      const response = await doPost(urls?.playbookBatchQuestions, arg);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const playbookBatchQuestionsSlice = createSlice({
  name: "playbookBatchQuestions",
  initialState: {
    isLoading: false,
    success: false,
    data: false,
    error: null,
  },
  reducers: {
    playbookBatchQuestionsReset: () => {
      return {
        isLoading: false,
        success: false,
        data: false,
        error: null,
      };
    },
  },
  extraReducers: {
    [playbookBatchQuestions.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      state.success = true;
      state.data = payload;
      state.error = null;
    },
    [playbookBatchQuestions.pending]: (state) => {
      state.isLoading = true;
      state.success = false;
      state.data = false;
    },
    [playbookBatchQuestions.rejected]: (state, { payload }) => {
      state.isLoading = false;
      state.data = false;
      state.error = payload;
    },
  },
});

export const { playbookBatchQuestionsReset } =
  playbookBatchQuestionsSlice.actions;
